import { getComplexInformation } from 'api/offer';
import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, setNormalMarkerInfo } from 'redux/store/mapReducer';
import { RootState } from 'redux/store/rootReducer';
import { OfferMarker } from 'types/offer';

export interface NormalMapMarkerProps {
  map?: naver.maps.Map;
  markerInfo: OfferMarker;
  onClickMarker: (bldNm: string) => void;
  selectedBldNm: string;
}

const NormalMapMarker: FunctionComponent<NormalMapMarkerProps> = (props) => {
  const { map, markerInfo, onClickMarker, selectedBldNm } = props;
  if (!map) return null;
  const NORMAL_MAP_ZOOM_LEVEL = {
    sido: 10,
    sigungu: 12,
    dong: 13,
    complex: 14,
  };
  const dispatch = useDispatch();
  const { modal } = useSelector((state: RootState) => state.mapStore);
  const { latitude, longitude } = markerInfo.center;
  const zoom = map.getZoom();

  const defaultIcon = [
    `<div style="display:flex; flex-direction: column; align-items: center; justify-content:center; background-color:#ef152fb3; width: 40px; height: 40px; border-radius:40px; border: 1px solid #EF152F;" >`,
    `<div style="font-size:14px; color: #FFFFFF; margin-top: 2px;">${markerInfo.count}</div>`,
    '</div>',
  ].join('');

  const selectedIcon = [
    `<div style=" display:flex; flex-direction: column; align-items: center; justify-content:center; background-color:#ffffffb3; width: 40px; height: 40px; border-radius:40px; border: 1px solid #EF152F;" >`,
    `<div style="font-size:14px; color: #EF152F; margin-top: 2px;">${markerInfo.count}</div>`,
    '</div>',
  ].join('');

  const MARKER_SIZE = {
    M: 64,
    L: 72,
  };

  let markerSize = MARKER_SIZE.M;
  if (zoom <= NORMAL_MAP_ZOOM_LEVEL.sido) {
    markerSize = MARKER_SIZE.L;
  }

  const clusteredIcon = [
    `<div style="width: ${markerSize}px; height: ${markerSize}px; border-radius:64px; border: 1px solid #EF152F;  display:flex; flex-direction: column; align-items: center; justify-content:center; background-color:#ef152fb3" >`,
    `<div style="font-size:10px; color: #FFFFFF; text-align: center;">${markerInfo?.districtName}</div>`,
    `<div style="font-size:16px; color: #FFFFFF; margin-top: 2px;">${markerInfo.count}</div>`,
    '</div>',
  ].join('');

  const markerOptions = {
    size: new naver.maps.Size(42, 42),
    anchor: new naver.maps.Point(21, 21),
    origin: new naver.maps.Point(0, 0),
  };

  useEffect(() => {
    const marker = new naver.maps.Marker({
      map,
      position: new naver.maps.LatLng(latitude, longitude),
      icon: {
        content: map?.getZoom() > 13 ? defaultIcon : clusteredIcon,
        ...markerOptions,
      },
    });

    changeMarkerIcon(marker);
    const clickListener = marker.addListener('click', () => {
      if (zoom >= NORMAL_MAP_ZOOM_LEVEL.complex) {
        getNormalInfoModal(markerInfo.complexId);
        dispatch(setModal(true));
        onClickMarker(markerInfo.bldNm);
      } else if (zoom <= NORMAL_MAP_ZOOM_LEVEL.sido) {
        zoomIn(NORMAL_MAP_ZOOM_LEVEL.sigungu);
        dispatch(setModal(false));
      } else {
        zoomIn(NORMAL_MAP_ZOOM_LEVEL.complex);
        dispatch(setModal(false));
      }
    });

    return () => {
      marker.setMap(null);
      marker.removeListener(clickListener);
    };
  }, [markerInfo, selectedBldNm, modal]);

  const changeMarkerIcon = (marker: naver.maps.Marker) => {
    marker.setIcon({
      ...markerOptions,
      content: getMarkerContent(),
    });

    marker.setMap(map);
  };

  const getMarkerContent = () => {
    if (markerInfo.bldNm === selectedBldNm && zoom > 13 && modal) {
      return selectedIcon;
    }

    if (zoom > NORMAL_MAP_ZOOM_LEVEL.dong) {
      return defaultIcon;
    }

    return clusteredIcon;
  };

  const getNormalInfoModal = async (complexId: number) => {
    const { data, error } = await getComplexInformation(complexId);

    if (error) {
      console.log('error');
      return;
    }

    if (data) {
      const newmarkerInfo = Object.assign(data, { count: markerInfo.count });
      dispatch(setNormalMarkerInfo(newmarkerInfo));
    }
  };

  const zoomIn = (zoomLevel: number) => {
    map.morph(new naver.maps.LatLng(latitude, longitude), zoomLevel);
  };

  return null;
};

export default NormalMapMarker;
